// Flattens the JSON:API ModelLikeSerializer payload (BE PR #16639) into the rows
// the likers list renders. Defensive by design, like normalizeComments: a
// partial payload degrades to an empty list instead of throwing.
export const normalizeLiker = (node) => {
  if (!node) {
    return null
  }

  const { id, attributes = {} } = node
  const { createdAt, user } = attributes

  // The serializer emits `user: null` when the account behind a like is gone.
  // Such a row has nothing to render, so it is dropped - the header count comes
  // from meta.totalItemsCount and may therefore exceed the rows on screen.
  if (!user) {
    return null
  }

  return {
    id: Number(id),
    createdAt: createdAt || null,
    username: user.username || '',
    displayName: user.displayName || user.username || '',
    avatarUrl: user.avatarUrl || null,
  }
}

export const normalizeLikersList = (payload) => {
  const list = payload?.data

  if (!Array.isArray(list)) {
    return []
  }

  return list.map(normalizeLiker).filter(Boolean)
}
